import { findWorkflowStep } from '@takeshape/schema';
import { getResourceString } from "./resources.js";
export function canEditWithStatus({ projectId, accessPolicy, workflow }, stepKey) {
    return accessPolicy({
        action: 'workflow-step:edit',
        resource: getResourceString('workflow-step', {
            projectId,
            workflowName: workflow.name,
            key: stepKey
        })
    });
}
export function getWorkflowPermissionsByStatus(context, currentStatus) {
    return context.workflow.steps.map((s) => canChangeStatus(context, currentStatus, s.key));
}
export function canChangeStatus(context, from, to) {
    const { workflow } = context;
    const fromRes = findWorkflowStep(workflow, from);
    const toRes = findWorkflowStep(workflow, to);
    if (!fromRes || !toRes) {
        return false;
    }
    const { index: fromIndex, step: fromStep } = fromRes;
    const { index: toIndex, step: toStep } = toRes;
    const canEdit = canEditWithStatus.bind(null, context);
    if (fromIndex < toIndex) {
        // Slide forward
        for (let i = fromIndex; i < toIndex; i++) {
            const step = workflow.steps[i];
            if (!canEdit(step.key)) {
                return false;
            }
        }
        return true;
    }
    // Jump backwards
    return canEdit(fromStep.key) && canEdit(toStep.key);
}
